<div class="fl destination-column pv1 dn db-ns" *ngIf="(flightTrackerText$ | async) as flightTrackerText">
  <div class="flex flex-column">
    <span class="clip">{{ flightTrackerText?.tabletStickyDestination }}</span>
    <div class="f4">{{ leg?.destinationAirport }}</div>
    <div class="pt1">{{ flightTrackerText?.terminal }} {{ leg?.destinationTerminal }}</div>
    <div class="pb1">{{ flightTrackerText?.gate }} {{ leg?.destinationGate }}</div>
  </div>
</div>
